import { Create, SimpleForm, useCreate, useRedirect, useNotify } from "react-admin";

import { AdministrationServicePath, SPECIALITIES } from "utils/constants";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateSpecialities = () => {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();

  const specialitySave = async data => {
    if (data.studyDurationDtos && data.studyDurationDtos.length > 0) {
      data.studyDurationDtos = data.studyDurationDtos.map(sd => ({
        ...sd,
      }));
    }

    create(
      AdministrationServicePath + SPECIALITIES,
      { data },
      {
        onSuccess: () => {
          redirect("list", AdministrationServicePath + SPECIALITIES);
        },
        onError: error => {
          notify(`Error: ${error.message || "Грешка при създаване на специалност"}`, { type: "error" });
        },
      },
    );
  };

  return (
    <Create
      title="Създаване на специалност"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm onSubmit={specialitySave}>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};
export default CreateSpecialities;
